import { render } from "./property-geolink.vue?vue&type=template&id=2871c088"
import script from "./property-geolink.vue?vue&type=script&lang=js"
export * from "./property-geolink.vue?vue&type=script&lang=js"

import "./property-geolink.vue?vue&type=style&index=0&id=2871c088&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__